import { faFlag } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "@mui/material";

import { StyledButton } from "./styled";

interface StartingPointButtonProps {
  isStartingPoint: boolean;
  disabled?: boolean;
  onSetStartingPoint: () => void;
}

export default function StartingPointButton({
  isStartingPoint,
  disabled = false,
  onSetStartingPoint,
}: StartingPointButtonProps) {
  const theme = useTheme();

  return (
    <StyledButton
      variant="contained"
      startIcon={isStartingPoint && <FontAwesomeIcon icon={faFlag} />}
      disabled={disabled || isStartingPoint}
      onClick={isStartingPoint ? undefined : onSetStartingPoint}
      $isStarting={isStartingPoint}
      $theme={theme}
      data-testid="starting-point-button"
    >
      {isStartingPoint ? "Starting point" : "Set starting point"}
    </StyledButton>
  );
}
